import React from 'react'
import Container from '../Container'
import style from './style/error.module.scss'

interface IState {
  hasError: boolean
}

class ErrorBoundary extends React.Component<any, IState> {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch (): void {
    this.setState({ hasError: true })
  }

  render (): any {
    if (this.state.hasError) {
      return (
        <Container className={style.error}>
          <h1 className={style.header}>Что-то пошло не так. Попробуйте позже</h1>
          <a href='/'>На главную</a>
        </Container>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
